// src/Components/Loader/LoadingSpinner.js
import React from "react";
import { ClipLoader } from "react-spinners";

const LoadingSpinner = ({ loading }) => {
  return (
    loading && (
      <div style={styles.overlay}>
        <ClipLoader size={60} color="var(--primary-color)" loading={loading} />
      </div>
    )
  );
};

const styles = {
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100vw",
    height: "100vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "rgba(255, 255, 255, 0.7)",
    zIndex: 9999,
  },
};

export default LoadingSpinner;
